





import { Component, Vue } from 'vue-property-decorator';

import Dropdown from '@/shared/components/Dropdown.component.vue';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    Dropdown,
    ExpansionPanel,
  },
})
export default class DropdownPartial extends Vue {
  private dropdownData = [
    { id: 1, name: 'Ingresos' },
    { id: 2, name: 'Gastos' },
    { id: 3, name: 'Todos los movimientos' },
  ];
  private elementSelected = this.dropdownData[0];
}
